import { FormCard } from '@qbe/ads-blocks-forms';
import { Spacer, Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';
import { toSitecoreUrl } from '~/utils';

interface MembershipConfirmationPanelProps {
  intermediaryCode: string;
}

export const MembershipConfirmationPanel: React.FC<MembershipConfirmationPanelProps> = ({
  intermediaryCode,
}) => {
  const { getTextContent, getJSXContent } = useAppContent({ basePath: 'dsme.confirmation' });
  const title = getTextContent(`membership.${intermediaryCode}.title`);
  const description = getTextContent(`membership.${intermediaryCode}.description`);
  const partnerLogoId = getTextContent(`membership.${intermediaryCode}.caption`);

  return title && description ? (
    <FormCard variant="sectionTitle" title={getTextContent(`membership.${intermediaryCode}.title`)}>
      <Typography align="center">
        {getJSXContent(`membership.${intermediaryCode}.description`) || ''}
      </Typography>
      {partnerLogoId && (
        <>
          <Spacer size="lg" />
          <img
            src={toSitecoreUrl(partnerLogoId)}
            alt={`${intermediaryCode} logo` as string}
            width={200}
            height="auto"
          />
        </>
      )}
    </FormCard>
  ) : null;
};
